import { FunctionComponent, useEffect } from 'react';
import { useCountries } from '../../hooks/useCountries';

/**
 * Redirects the old my bookings page to the new booking history page in new my account.
 */
export const MyBookings: FunctionComponent = () => {
    const { currentCountry } = useCountries();

    useEffect(() => {
        window.location.replace(currentCountry.urlProfile + '/booking-history');
    }, [currentCountry]);

    return null;
};
